/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyercreate2Inputs */

const en_checkinflyercreate2 = /** @type {(inputs: Checkinflyercreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create flyer`)
};

const de_checkinflyercreate2 = /** @type {(inputs: Checkinflyercreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer erstellen`)
};

/**
* | output |
* | --- |
* | "Create flyer" |
*
* @param {Checkinflyercreate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyercreate2 = /** @type {((inputs?: Checkinflyercreate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyercreate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyercreate2(inputs)
	return de_checkinflyercreate2(inputs)
});
export { checkinflyercreate2 as "checkinFlyerCreate" }